import styled from 'styled-components';

export const IconWrapper = styled.div({
  marginRight: '20px',
});

export const TextWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
});
